import React, { useEffect, useRef } from "react";
import useState from "react-usestateref";
import NeuroCareHeader from "../NeuroCareHeader";
import { db, patientDb } from "../firebase/firebase";
import { ref, child, get } from "firebase/database";
import { Button, Layout, Calendar, ConfigProvider, Input, Table } from "antd";
import moment from "moment";
import "moment/locale/ko";
import locale from "antd/es/locale/ko_KR";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";
import { useAuth } from "../AuthProvider";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Loader from "./Loader";
import CustomLoadingOverlay from "./CustomLoadingOverlay";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const Cms = () => {
  const { user } = useAuth();
  const [data, setData] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showData, setShowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([])
  const [init, setInit] = useState(false);
  function datePart(s) {
    if (!s || typeof s !== "string") return "";
    const i = s.indexOf("-");
    return i > 0 ? s.slice(0, i) : s.slice(0, 8);
  }
  const fetchAllPatientData = async () => {
    try {
      const accountId = String(user?.id ?? "").trim();
      if (!accountId) throw new Error("user.id가 비어 있습니다.");

      const customersSnap = await get(
        child(ref(patientDb), `Account/${user.id}/Customers`)
      );
      const patientEntries = [];
      const patientIndex = new Map();

      if (customersSnap.exists()) {
        customersSnap.forEach((c) => {
          const dateTime = c.key;
          const date = datePart(dateTime);
          const val = c.val() || {};
          const code = String(val.code ?? "").trim();
          const name = String(val.name ?? "").trim();

          if (!date || !code) return;
          const entry = { date, dateTime, code, name };
          patientEntries.push(entry);

          const k = `${code}|${date}`;
          if (!patientIndex.has(k)) patientIndex.set(k, []);
          patientIndex.get(k).push(entry);
        });
      }

      const patientsSnap = await getDocs(
        collection(db, "Accounts", user.id, "Patients")
      );

      const allTests = [];
      const testsPromises = patientsSnap.docs.map(async (pDoc) => {
        const cmsSnap = await getDocs(
          collection(db, "Accounts", accountId, "Patients", pDoc.id, "CMS")
        );
        cmsSnap.forEach((t) => {
          const testId = t.id;
          const date = datePart(testId);
          allTests.push({
            date,
            dateTime: testId,
            patientId: pDoc.id,
            testId,
            test: t.data() || {},
          });
        });
      });
      await Promise.all(testsPromises);

      const matched = [];
      const onlyTests = [];
      const usedPatientEntry = new Set();

      for (const test of allTests) {
        const k = `${test.patientId}|${test.date}`;
        const bucket = patientIndex.get(k);
        if (bucket && bucket.length > 0) {
          const entry = bucket.shift();
          usedPatientEntry.add(`${entry.code}|${entry.date}|${entry.dateTime}`);

          matched.push({
            date: test.date,
            dateTime: test.dateTime,
            code: entry.code,
            name: entry.name,
            patientId: test.patientId,
            testId: test.testId,
            test: test.test,
          });
          if (bucket.length === 0) patientIndex.delete(k);
        } else {
          onlyTests.push(test);
        }
      }

      const onlyPatients = patientEntries.filter(
        (e) => !usedPatientEntry.has(`${e.code}|${e.date}|${e.dateTime}`)
      );

      const matchedRows = matched.map((m) => {
        const total = m.test?.total_data || {};

        return {
          date: m.date,
          dateTime: m.dateTime,
          code: m.code,
          name: m.name,
          patientId: m.patientId,
          face: total.face_score ?? null,
          motor: total.motor_score ?? null,
          speech: total.speech_score ?? null,
        };
      });
      const onlyPatientRows = onlyPatients.map((p) => ({
        date: p.date,
        dateTime: p.dateTime,
        code: p.code,
        name: p.name,
        patientId: p.code,
        face: null,
        motor: null,
        speech: null,
      }));

      const allRows = [...matchedRows, ...onlyPatientRows].sort((a, b) =>
        b.dateTime.localeCompare(a.dateTime)
      );

      const now = new Date();
      const yyyy = now.getFullYear();
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const dd = String(now.getDate()).padStart(2, "0");
      const today = `${yyyy}${mm}${dd}`;

      const filteredData = allRows.filter((item) => item.date == today);
      setShowData(filteredData);
      setData(allRows);
      setLoading(false);
    } catch (err) {
      console.error("데이터 로딩 오류:", err);
    }
  };
  useEffect(() => {
    if (!init) {
      setInit(true);
      fetchAllPatientData();
    }
    return () => {};
  }, [user]);

  const handleSendSMS = () => {
    const size = selectedRows.length
    if(size>0){
        const confirmed = window.confirm(`${size}명에게 메세지를 전송하시겠습니까?`);
        if(confirmed){
            window.alert('전송되었습니다.');
        }
    }else{
        window.alert('선택된 환자가 없습니다.');
    }
  };

  const handleDateChange = (date) => {
    const now = date.format("YYYYMMDD");
    const filteredData = data.filter((item) => item.date == now);
    setShowData([...filteredData]);
  };
  const gridApiRef = useRef(null);

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    params.api.sizeColumnsToFit();
  };
  const CircleRenderer = (params) => {
    const value = params.value;
    let color = "white";

    if (value !== undefined && value !== null) {
      if (value >= 50) color = "#00b050";
      else color = "#ff0000";
    }

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <div
          style={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            border: "1px solid #808080",
            backgroundColor: color,
          }}
        />
      </div>
    );
  };
  const AlarmRenderer = (params) => {
    const handleClick = () => {
      const name = params.data?.name || "이 환자";
      const confirmed = window.confirm(`${name} 환자에게 메세지를 전송하시겠습니까?`);
      if (confirmed) {
        window.alert('전송되었습니다.');
      }
    };
  
    return (
      <div
        style={{
          textAlign: "center",
          fontSize: "18px",
          cursor: "pointer", 
          userSelect: "none",
        }}
        onClick={handleClick}
        title="문자 전송"
      >
        📩
      </div>
    );
  };
  const columnDefs = [
    { headerName: "일시", field: "dateTime" },
    { headerName: "환자명", field: "name" },
    { headerName: "Face", field: "face", cellRenderer: CircleRenderer },
    { headerName: "Motor", field: "motor", cellRenderer: CircleRenderer },
    { headerName: "Speech", field: "speech", cellRenderer: CircleRenderer },
    {
      headerName: "문자",
      field: "alarm",
      cellRenderer: AlarmRenderer,
      width: 80,
    },
  ];
  const onSelectionChanged = ()=> {
    const selectData= gridApiRef.current.getSelectedRows()
    setSelectedRows(selectData)
  };
  return (
    <Layout style={{ background: "#ffffff" }}>
      <NeuroCareHeader selectedMenu={"cms"} />
      {/* {loading && <Loader />} */}
      <ConfigProvider locale={locale}>
        <div style={{ display: "flex", width: "100%", height: "80%" }}>
          <div className="calendarContainer">
            <Calendar fullscreen={false} onSelect={handleDateChange} />
          </div>

          <div className="recordContainer">
            <div className="panel">
              <div className="gridWrap">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100%", width: "100%" }}
                >
                  <AgGridReact
                    onGridReady={onGridReady}
                    rowData={showData}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: true, filter: false }}
                    loadingOverlayComponent={CustomLoadingOverlay}
                    loadingOverlayComponentParams={{
                      loadingMessage: "로딩 중입니다...",
                    }}
                    loading={loading}
                    rowSelection={{ mode: "multiRow" }}
                    suppressRowVirtualisation={true}
                    domLayout="autoHeight"
                    overlayNoRowsTemplate={'<span style="padding: 10px; color: #888;">데이터가 없습니다.</span>'}
                    onSelectionChanged={onSelectionChanged}
                  />
                </div>
              </div>

              <div className="footerBar">
                <button className="primaryBtn" onClick={handleSendSMS}>
                  메세지 전송
                </button>
              </div>
            </div>
          </div>
        </div>
      </ConfigProvider>
    </Layout>
  );
};
export default Cms;
